/**
 * デフォルト列設定（14列固定）
 */
export const DEFAULT_COLUMNS = [
    { key: 'projectNo', label: '案件No.', visible: true, order: 1, required: true, width: '76px' },
    { key: 'storeNo', label: '店No.', visible: true, order: 2, required: true, width: '50px' },
    { key: 'storeName', label: '店名', visible: true, order: 3, required: true, width: '70px' },
    { key: 'zoName', label: 'ZO名', visible: true, order: 4, width: '40px' },
    { key: 'doName', label: 'DO名', visible: true, order: 5, width: '40px' },
    { key: 'contractType', label: '契約タイプ', visible: true, order: 6, width: '50px' },
    { key: 'ownershipType', label: '所有区分', visible: true, order: 7, width: '50px' },
    { key: 'businessType', label: '業務種別', visible: true, order: 8, width: '50px' },
    { key: 'programName', label: 'プログラム名', visible: true, order: 9, width: '88px' },
    { key: 'projectStatus', label: '案件状況', visible: true, order: 10, width: '64px' },
    { key: 'status', label: 'ステータス', visible: true, order: 11, width: '52px' },
    { key: 'startDate', label: '案件開始日', visible: true, order: 12, width: '76px' },
    { key: 'ofcName', label: 'OFC名', visible: true, order: 13, width: '64px' },
    { key: 'applicationType', label: '申請区分', visible: true, order: 14, width: '64px' }
];
/**
 * ColumnConfig[]のディープコピーを返す(Generated by GPT-4o)
 */
export function copyColumnConfig(obj) {
    // オブジェクトがnullまたはオブジェクトでない場合はそのまま返す
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    // 配列の場合
    if (Array.isArray(obj)) {
        const copy = [];
        for (let i = 0; i < obj.length; i++) {
            copy[i] = copyColumnConfig(obj[i]);
        }
        return copy;
    }
    // オブジェクトの場合
    const copy = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            copy[key] = copyColumnConfig(obj[key]);
        }
    }
    return copy;
}
/**
 * 列設定の妥当性をチェックする
 */
export function validateColumnConfig(config) {
    if (!Array.isArray(config) || config.length === 0) {
        return false;
    }
    // 重複チェック
    const keys = config.map(c => c.key);
    const uniqueKeys = new Set(keys);
    if (keys.length !== uniqueKeys.size) {
        return false;
    }
    // 必須フィールドチェック
    return config.every(c => c.key &&
        c.label &&
        typeof c.visible === 'boolean' &&
        typeof c.order === 'number');
}
/**
 * 列設定を順序でソートする
 */
export function sortColumnsByOrder(columns) {
    return columns.sort((a, b) => a.order - b.order);
}
/**
 * 表示可能な列のみを取得する
 */
export function getVisibleColumns(columns) {
    return columns.filter(c => c.visible);
}
